import {getSafely} from 'shared/web';

import {CHART_TOOLBAR_HIGHLIGHT_KEYS, ChartToolbarHighlights} from '../types/ChartToolbarHighlight';

export function hasActiveChartToolbarHighlights(highlights: ChartToolbarHighlights) {
  return CHART_TOOLBAR_HIGHLIGHT_KEYS.some((highlight) => getSafely(highlights, highlight, false));
}

export function hasActiveChartToolbarFilters(
  highlights: ChartToolbarHighlights,
  selectedSellerId: string | null
) {
  return hasActiveChartToolbarHighlights(highlights) || selectedSellerId !== null;
}
